import React, { Component } from "react";
import { connect } from 'react-redux';
import { userActions } from '../../_actions';
import LoadingOverlay from 'react-loading-overlay';
import Timer from 'otp-timer'
import Logo from './1.png'
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';


class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldslogin: {},
      errorslogin: {},
      passwordVisible: false,

    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    console.log('nextProps.authentication.otpSentForgotPass', nextProps.authentication.otpSentForgotPass);
    if (nextProps.authentication.otpSentForgotPass) {
      return {
        ...nextProps,

      }
    }
    else {
      return {
        ...nextProps
      }
    }
  }

  inputChange = (e) => {

    e.preventDefault();
    let { name, value } = e.target;
    let fieldslogin = this.state.fieldslogin;
    let errorslogin = this.state.errorslogin;
    fieldslogin[name] = value;
    errorslogin[name] = "";
    this.setState({ fieldslogin, errorslogin });
  }



  forgotPasswordSubmit = (e) => {
    if (this.handleValidationLogin()) {

      let { userName } = this.state.fieldslogin;
      this.props.dispatch(userActions.forgotPassword({
        email: userName,
      }, this.props));

    }
  }


  otpSubmit = () => {
    if (this.handleValidationOTP()) {
      let { token } = this.props.forgotuser;
      let { OTP, password, confirmPassword } = this.state.fieldslogin;
      this.props.dispatch(userActions.forgotUpdatePassword({
        token: token, newPassword: password,
        otp: OTP
      }, this.props));
    }
  }
  resetForm = (e) => {
    e.preventDefault();
    this.setState({
      fieldslogin: {},
      errorslogin: {},
    })
    this.hideErrorMessage();
  }

  handleValidationOTP = () => {
    let fieldslogin = this.state.fieldslogin;
    let errorslogin = {};
    let formIsValid = true;

    //Name
    if (!fieldslogin["OTP"]) {
      formIsValid = false;
      errorslogin["OTP"] = "Please enter OTP!";
    }
    //password
  

    if (!fieldslogin.password || fieldslogin.password.length < 8) {
      formIsValid = false;
      errorslogin.password = "Password must be at least 8 characters long";
    } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}/.test(fieldslogin.password)) {
      formIsValid = false;
      errorslogin.password = "Password must contain at least one lowercase letter, one uppercase letter, one number, and one special character";
      // errorslogin.password = "";
    }




    this.setState({ errorslogin: errorslogin });
    return formIsValid;
  }


  handleValidationLogin = () => {
    let fieldslogin = this.state.fieldslogin;
    let errorslogin = {};
    let formIsValid = true;

    //Email

    if (!fieldslogin["userName"] || fieldslogin["userName"] === "") {
      formIsValid = false;
      errorslogin["userName"] = "Cannot Be Empty";
    }

    if (typeof fieldslogin["email"] !== "undefined" && fieldslogin["email"] !== "") {
      let lastAtPos = fieldslogin["email"].lastIndexOf('@');
      let lastDotPos = fieldslogin["email"].lastIndexOf('.');

      if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fieldslogin["email"].indexOf('@@') === -1 && lastDotPos > 2 && (fieldslogin["email"].length - lastDotPos) > 2)) {
        formIsValid = false;
        errorslogin["email"] = "Enter Valid Email!";
      }
    }

    this.setState({ errorslogin: errorslogin });
    return formIsValid;
  }

  componentDidMount() {
    this.props.dispatch(userActions.resetdata())
  }
  onClickMenu = (url) => {
    this.props.history.push(url)
  }

  togglePasswordVisibility = () => {
    this.setState(prevState => ({
      passwordVisible: !prevState.passwordVisible
    }));
  };

  // validation = () => {
  //   this.setState({ otpSentForgotPass: true })
  // };


  render() {
    let { otpSentForgotPass, forgotuser, loading } = this.props;
    const { errorslogin, passwordVisible } = this.state;

    return (
      <>

        <div >
          <LoadingOverlay
            active={loading}
            className="temp001"
            spinner
            text='Please wait...' />
        </div>


        <div className="overflow-y-auto">
          <div className="bg-cover bg-no-repeat overflow-y-auto bg-[#95CCC5]">
            <div className="h-screen flex flex-col justify-center py-10 px-3 sm:px-6 lg:px-8 z-20  overflow-y-auto">
              <div className="mx-auto w-full  max-w-lg">
                <div className="bg-[#CBD5E1] border border-gray-800  py-8 shadow rounded-3xl px-6 sm:px-12">
                  <div className="space-y-2 py-4">
                    <a className='cursor-pointer' onClick={() => this.onClickMenu('/')}  ><img src={Logo} alt="" className="text-center mx-auto h-28" /></a>
                    <h2 className="text-left text-3xl leading-9 font-bold uppercase text-[#005F60] tracking-wide">Physio Forgot Password</h2>
                  </div>


                  <form autoComplete="off" className="space-y-4">
                    <div className="space-y-1">
                      <label className="text-[#005F60] font-bold text-sm">Email</label>

                      <div className=" rounded-md shadow-sm relative">
                        <input disabled={otpSentForgotPass ? true : false} className={`appearance-none block w-full px-4 py-4 rounded-xl text-gray-800 bg-gray-50 focus:outline-none focus:border-gray-200 focus:bg-gray-100 focus:text-gray-800 transition duration-150 ease-in-out text-lg font-normal sm:leading-5 ${!this.state.errorslogin["userName"] ? "'border-opacity-20 border-opacity-100 border placeholder-gray-700" : "border-opacity-100 border border-red-500"}`}
                          id="userName" name="userName" placeholder="Email ID" type="userName" onChange={this.inputChange} />
                        {this.state.errorslogin["userName"] ?
                          <div className="invalid-feedback text-[#005F60]">
                            {this.state.errorslogin["userName"]}
                          </div>
                          : null}

                      </div>

                    </div>

                    {
                      otpSentForgotPass ?
                        <>
                          <div className="space-y-1">
                            <label className="text-[#005F60] font-bold text-sm">OTP <span className=" text-black font-normal text-sm">sent to {this.state.fieldslogin?.userName}</span></label>
                            <div className="mt-1 rounded-md shadow-sm relative">
                              <input maxLength="6" className={`appearance-none block w-full px-4 py-4 rounded-xl text-gray-800 bg-gray-50 focus:outline-none focus:border-gray-200 focus:bg-gray-100 focus:text-gray-800 transition duration-150 ease-in-out text-lg font-normal sm:leading-5 ${!this.state.errorslogin["OTP"] ? "'border-opacity-20 border-opacity-100 border placeholder-gray-700" : "border-opacity-100 border border-red-500 bg-dark-400"}`}
                                id="OTP" name="OTP" placeholder="OTP" type="number" onChange={this.inputChange} />
                              {this.state.errorslogin["OTP"] ?
                                <div className="invalid-feedback text-[#005F60]">
                                  {this.state.errorslogin["OTP"]}
                                </div>
                                : null}
                            </div>
                          </div>

                          {otpSentForgotPass ?
                            <div className="">
                              <Timer
                                textColor={"#005F60"}
                                seconds={1}
                                minutes={2}
                                ButtonText="Resend Otp"
                                buttonColor="#ffffff"
                                background={"#005F60"}
                                resend={this.forgotPasswordSubmit}
                              />
                            </div>
                            : null
                          }



                          <div className="space-y-1">
                            <label className="text-[#005F60] font-bold text-sm">New Password</label>
                            <div className="mt-1 rounded-md shadow-sm relative">
                              <input
                                className={`appearance-none  block w-full px-4 py-4 rounded-xl text-gray-800 bg-gray-50 focus:outline-none focus:border-gray-200 focus:bg-gray-100 focus:text-gray-800 transition duration-150 ease-in-out text-lg font-normal sm:leading-5 ${!errorslogin["password"]
                                  ? "'border-opacity-20 border-opacity-100 border placeholder-gray-700"
                                  : "border-opacity-100 border border-red-500 bg-dark-400"
                                  }`}
                                id="password"
                                name="password"
                                placeholder="New Password"
                                type={passwordVisible ? "text" : "password"}
                                onChange={this.inputChange}
                              />
                              {errorslogin["password"] ? (
                                <div className="invalid-feedback text-xs text-red-500">
                                  {errorslogin["password"]}
                                </div>
                              ) : null}
                              <span className="absolute top-5 right-5 text-gray-400 cursor-pointer" onClick={this.togglePasswordVisibility}>
                                {passwordVisible ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                              </span>
                            </div>
                          </div>
                        </>
                        : null
                    }


                    {/* {
                      otpSentForgotPass ?
                        <div className="flex items-center">
                          <Timer textColor={"#005F60"} seconds={1} minutes={2} ButtonText="Resend Otp" resend={this.forgotPasswordSubmit} />
                        </div>
                        : null
                    } */}





                    {
                      otpSentForgotPass ?
                        <div className=" mx-auto">
                          <button className="w-full mx-auto flex justify-center py-3 uppercase px-4 border text-lg font-semibold rounded-xl text-[#fff] bg-[#005F70] border-[#005F70] hover:bg-[#005F70] focus:outline-none  transition duration-150 ease-in-out" type="button" onClick={this.otpSubmit}>Verify OTP</button>
                        </div>
                        :
                        <div className=" mx-auto">
                          <button className="w-full mx-auto flex justify-center py-3 uppercase px-4 border text-lg font-semibold rounded-xl text-white bg-[#005F70] border-[#005F70] hover:bg-[#005F70] hover:text-white:outline-none transition duration-150 ease-in-out" type="button" onClick={this.forgotPasswordSubmit}>Recover Password</button>
                        </div>

                    }

                  </form>  <div className="leading-5 text-center py-2">
                    <p className="text-base font-semibold text-[#005F60]">Don't have an account?
                      <span className="cursor-pointer text-green-700 font-bold  hover:underline hover:text-shine focus:outline-none focus:underline transition ease-in-out duration-150" onClick={() => this.onClickMenu('signup')}> Sign up</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
function mapStateToProps(state) {
  const { loggingIn, forgotuser, otpSentForgotPass, loading } = state.authentication;
  const { users, authentication } = state;
  return {
    loggingIn,
    otpSentForgotPass,
    forgotuser,
    users,
    loading,
    authentication
  };
}
export default connect(mapStateToProps)(Signup);
